// Data import/export, NVE, green certificates, and miscellaneous data components
import { defineAsyncComponent } from 'vue'

export default {
  DataExportForm: defineAsyncComponent(() => import('../data_export_form.vue')),
  FileImport: defineAsyncComponent(() => import('../file_import.vue')),
  GreenBulkUpdateForm: defineAsyncComponent(
    () => import('../green_bulk_update_form.vue')
  ),
  GreenMonthsEditAll: defineAsyncComponent(
    () => import('../green_months_edit_all.vue')
  ),
  GreenMonthsIndex: defineAsyncComponent(
    () => import('../green_months_index.vue')
  ),
  HourlyValues: defineAsyncComponent(() => import('../hourly_values.vue')),
  NvePlantsTable: defineAsyncComponent(() => import('../nve/plants_table.vue')),
  NveShow: defineAsyncComponent(() => import('../nve/show.vue'))
}
